import script from "./Archiver.vue?vue&type=script&setup=true&lang=js"
export * from "./Archiver.vue?vue&type=script&setup=true&lang=js"

import "./Archiver.vue?vue&type=style&index=0&id=7c8e4c32&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8e4c32"]])

export default __exports__